import { useMemo, useState } from "react";
import { Link } from "react-router-dom";

import { RenderWhen, RLCard } from "../../../../../../components";
import VerticalDivider from "../../../../../../components/VerticalDivider";
import { COMPONENT_IDS } from "../../../../consts";
import { useLocalSampleSummaryParams } from "../../../../hooks";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import useUploadsData from "../../../sources/hooks/useUploadsData";
import { Tooltip } from "../common";
import { SourceInfo } from "./components";

import { SECTION_PATH } from "../../../../../../path";
import { filterConnectorUploads } from "../../utils";
import styles from "./sources.module.scss";

const NoSourcesComponent = () => (
  <div
    className="flex justify-content-center align-center"
    style={{ height: "100%" }}
  >
    No available EDR Sources
  </div>
);
const SourcesCard = () => {
  const { hash } = useLocalSampleSummaryParams();
  const [currIndex, setCurrIndex] = useState(0);
  const { data: uploadsData = [] } = useUploadsData(hash || "");

  const connectorUploads = useMemo(
    () => filterConnectorUploads(uploadsData),
    [uploadsData]
  );
  const total = connectorUploads?.length || 0;

  return (
    <RLCard
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              message={DESCRIPTIONS[COMPONENT_IDS.SOURCES]}
              placement="top"
            >
              <span>Detection Sources</span>
            </Tooltip>
          }
          LinkComponent={
            <RenderWhen condition={Boolean(total)}>
              <div className="flex align-center h-100">
                <RenderWhen condition={total > 0}>
                  <RLCard.HeaderNavigation
                    selected={currIndex}
                    total={total}
                    onClick={setCurrIndex}
                  />
                  <VerticalDivider className="h-100" />
                </RenderWhen>
                <Link
                  className={styles.link}
                  to={SECTION_PATH.SOURCES_UPLOADS}
                  data-testid="report_summary_sample_sources_link"
                >
                  See All Sources
                </Link>
              </div>
            </RenderWhen>
          }
        />
      }
      content={
        <RLCard.Content>
          <RenderWhen condition={total > 0} fallback={<NoSourcesComponent />}>
            <SourceInfo uploadSource={connectorUploads[currIndex]} />
          </RenderWhen>
        </RLCard.Content>
      }
      data-testid="report_summary_sample_description_card"
    />
  );
};

export default SourcesCard;
